(() => {
  const ADDED_MS = 1200;
  const DRAG_THRESHOLD_PX = 5;

  const init = (root) => {
    if (root.dataset.productReady) return;
    root.dataset.productReady = 'true';

    const form = document.getElementById(root.dataset.formId);
    const button = form ? form.querySelector('[data-add-button]') : null;
    const error = root.querySelector('[data-form-error]');
    let addedTimer;

    const selectedRadio = () => root.querySelector('input[type="radio"][name="id"]:checked');

    const setButton = (available) => {
      if (!button) return;
      clearTimeout(addedTimer);
      button.classList.remove('is-added');
      button.disabled = !available;
      button.textContent = available ? button.dataset.labelAdd : button.dataset.labelSoldOut;
    };

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const updateDots = (gallery) => {
      const dots = gallery.parentElement.querySelectorAll('[data-gallery-dot]');
      const index = Math.round(gallery.scrollLeft / gallery.clientWidth);
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const scrollToIndex = (gallery, index) => {
      gallery.scrollTo({ left: index * gallery.clientWidth, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    };

    const enableMouseDrag = (gallery) => {
      let startX = 0;
      let startScroll = 0;
      let pressed = false;
      let dragging = false;

      gallery.addEventListener('dragstart', (event) => event.preventDefault());

      gallery.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        if (gallery.scrollWidth <= gallery.clientWidth) return;
        pressed = true;
        startX = event.clientX;
        startScroll = gallery.scrollLeft;
      });

      gallery.addEventListener('pointermove', (event) => {
        if (!pressed) return;
        const delta = event.clientX - startX;
        if (!dragging) {
          if (Math.abs(delta) < DRAG_THRESHOLD_PX) return;
          dragging = true;
          gallery.setPointerCapture(event.pointerId);
          gallery.classList.add('is-dragging');
        }
        gallery.scrollLeft = startScroll - delta;
      });

      const release = () => {
        pressed = false;
        if (!dragging) return;
        dragging = false;
        const index = Math.round(gallery.scrollLeft / gallery.clientWidth);
        scrollToIndex(gallery, index);
        // Snap stays off until the settle scroll ends, or mandatory snap jumps to the nearest slide mid-animation.
        const restore = () => gallery.classList.remove('is-dragging');
        if ('onscrollend' in gallery) gallery.addEventListener('scrollend', restore, { once: true });
        else setTimeout(restore, 400);
      };

      gallery.addEventListener('pointerup', release);
      gallery.addEventListener('pointercancel', release);
    };

    const selectVariant = (radio) => {
      const id = radio.value;
      root.querySelectorAll('[data-variant-show]').forEach((el) => {
        el.hidden = el.dataset.variantShow !== id;
      });
      root.querySelectorAll('[data-variant-show][hidden] video').forEach((video) => video.pause());
      setButton(radio.dataset.available === 'true');
      if (error) error.hidden = true;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      window.history.replaceState(window.history.state, '', url);

      const gallery = root.querySelector(`[data-variant-show="${id}"] [data-gallery]`);
      if (gallery) {
        gallery.scrollLeft = 0;
        updateDots(gallery);
      }
    };

    root.addEventListener('change', (event) => {
      const target = event.target;
      if (target instanceof HTMLInputElement && target.type === 'radio' && target.name === 'id') {
        selectVariant(target);
      }
    });

    root.querySelectorAll('[data-gallery]').forEach((gallery) => {
      gallery.addEventListener('scroll', () => updateDots(gallery), { passive: true });
      enableMouseDrag(gallery);
      gallery.parentElement.querySelectorAll('[data-gallery-dot]').forEach((dot) => {
        dot.addEventListener('click', () => scrollToIndex(gallery, Number(dot.dataset.galleryDot)));
      });
    });

    const models = root.querySelectorAll('model-viewer');
    if (models.length && window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([
        { name: 'model-viewer', version: '1.12', onLoad: () => {} },
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: (errors) => {
            if (errors || !window.Shopify.ModelViewerUI) return;
            models.forEach((model) => new window.Shopify.ModelViewerUI(model));
          },
        },
      ]);
    }

    if (!form || !button) return;

    form.addEventListener('submit', async (event) => {
      if (!window.EmmettCart) return;
      event.preventDefault();

      const id = Number(new FormData(form).get('id'));
      if (!id) return;

      button.disabled = true;
      if (error) error.hidden = true;

      try {
        await window.EmmettCart.add([{ id, quantity: 1 }]);
        window.EmmettCart.open();
        button.disabled = false;
        button.textContent = button.dataset.labelAdded;
        button.classList.add('is-added');
        addedTimer = setTimeout(() => {
          const radio = selectedRadio();
          setButton(radio ? radio.dataset.available === 'true' : true);
        }, ADDED_MS);
      } catch (description) {
        const radio = selectedRadio();
        setButton(radio ? radio.dataset.available === 'true' : true);
        if (error) {
          error.textContent = typeof description === 'string' ? description : (description && description.message) || '';
          error.hidden = !error.textContent;
        }
      }
    });
  };

  const initAll = () => document.querySelectorAll('[data-product-section]').forEach(init);

  initAll();
  document.addEventListener('shopify:section:load', initAll);

  document.addEventListener('shopify:block:select', (event) => {
    if (event.target instanceof HTMLDetailsElement) event.target.open = true;
  });
})();
